import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
import i18next from "i18next";
import AppUtil from "utilities/AppUtil";

const t = i18next.getFixedT();

const _urlPrefix = "/reimbursement";

export const reduceAddReimbursement = createAsyncThunk(
  "reimbursement/reduceAddReimbursement",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      data: snakecaseKeys(params),
      method: "POST",
      successMessage: t('toast.create.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchListReimbursement = createAsyncThunk(
  "reimbursement/fetchListReimbursement",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceDeleteReimbursement = createAsyncThunk(
  "reimbursement/reduceDeleteReimbursement",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/delete`,
      method: "DELETE",
      data: snakecaseKeys(params),
      successMessage: t('toast.remove.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceRejectReimbursement = createAsyncThunk(
  "reimbursement/reduceRejectReimbursement",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/reject-reimbursement`,
      method: "PUT",
      data: snakecaseKeys(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const slice = createSlice({
  name: "reimbursement",
  initialState: {

  },
  reducers: {

  },
  extraReducers: {

  }
});

export default slice.reducer;
